/* src/app/calender/gcsetimetable/gcsetimetable.component.css */
.main-wrapper {
  margin-top: 120px;
  width: 100%;
  height: 700px;
  background-image: url(/assets/images/main-img-gcse.jpg);
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 0;
}
.nav-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 0;
  margin-right: 0;
  background-color: white;
  padding: 10px 20px;
  border-radius: 0 0 0 15px;
}
.nav-item {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.nav-button {
  background-color: #ff6200;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.nav-button:hover {
  background-color: #e55a00;
}
.content {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px 30px;
  border-radius: 0 15px 0 0;
  text-align: center;
  width: 700px;
}
.content h1 {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
.content h2 {
  font-size: 24px;
  font-weight: normal;
  color: #333;
  margin-bottom: 5px;
}
.content p {
  font-size: 16px;
  color: #666;
}
.cal-inst {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.cal-inst h1 {
  font-weight: bold;
}
.cal-inst h2 {
  font-size: 24px;
}
.logo3 {
  margin: 15px;
  width: 0px;
  height: 0px;
}
.hero-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  flex-direction: column;
}
.hs-head {
  background-color: #cecece;
  padding-left: 10px;
  padding-right: 10px;
}
.hero-section h2 {
  margin: 0;
  font-size: 32px;
}
.hero-section h4 {
  font-weight: 400;
  font-size: 22px;
}
.hs-h2 {
  font-size: 36px;
  font-weight: bold;
}
.hs-h1 {
  font-size: 48px;
  font-weight: bold;
}
.stripe {
  display: flex;
  margin-top: 25px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  background-color: #E7E7E7;
}
.stripe h3 {
  font-weight: 400;
}
.test-menu {
  display: flex;
  flex-direction: row;
  align-self: center;
}
.btn-tab {
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  background-color: #f0f0f0;
  font-size: 16px;
  margin: 10px;
  transition: all 0.3s ease;
}
.btn-tab.active {
  background-color: #4780f1;
  font-weight: bold;
  color: white;
}
.container {
  width: 90%;
  margin: 50px auto;
  padding: 20px;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 670px;
}
.header2 {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
  margin-top: 25px;
}
.heading {
  font-size: 24px;
  font-weight: 1000;
  color: rgb(255, 255, 255);
  padding-left: 0px;
}
.logo-mocktest {
  width: 180px;
  height: 40px;
}
.exam2 {
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-size: 24px;
  border-radius: 10px;
  padding-right: 10px;
  padding-left: 10px;
}
.tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1;
}
.tab {
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  background-color: #f0f0f0;
  font-size: 16px;
  transition: all 0.3s ease;
}
.tab.active {
  background-color: #f38d19;
  font-weight: bold;
  color: white;
}
.timetable-wrapper {
  flex: 1;
  overflow-y: auto;
}
.timetable-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.timetable-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.timetable-wrapper::-webkit-scrollbar-thumb {
  background: #dcd6ff;
  border-radius: 10px;
}
.timetable-wrapper::-webkit-scrollbar-thumb:hover {
  background: #bcb2ff;
}
.timetable-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #dcd6ff #f1f1f1;
}
.timetable {
  margin-top: 20px;
}
.test-row {
  height: 200px;
  display: flex;
  align-items: center;
  background-color: #f6f6f6;
  margin: 10px 0;
  border-radius: 15px;
}
.test-info.enhanced {
  height: 200px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #FDCA93;
  border-radius: 15px 0 0 15px;
  text-align: center;
}
.testTopic {
  margin-bottom: 5px;
}
.test-date {
  width: 70px;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  background-color: #fff;
  padding: 5px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.test-info.enhanced {
  border-left: 10px solid #e2e1e1;
  background-color: #ebebeb;
}
.testName {
  margin-bottom: 0px;
}
.test-centers {
  flex: 3;
  display: flex;
  gap: 20px;
  margin-left: 20px;
}
.center {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  background-color: #fafafa;
  padding: 10px;
  border-radius: 10px;
  border: 1px;
  border: 1px solid #b1b1b1;
  text-align: center;
}
.test-name {
  font-size: 22px;
  font-weight: bold;
}
.center.online {
  background-color: #e0f0d4;
  color: green;
}
.book-btn {
  display: inline-block;
  background-color: #f38d19;
  padding: 5px 15px;
  font-size: 16px;
  color: #fefefe;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  min-width: 80px;
}
.book-btn:hover {
  background-color: #f2985d;
  color: white;
  font-size: 18px;
}
.af-ts {
  display: flex;
  justify-content: center;
  align-items: center;
}
.af-ts h1 {
  text-align: center;
  margin-right: 25px;
  margin-left: 25px;
  margin-top: 80px;
}
.ft-sc {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  background-color: #fafafa;
  align-items: center;
}
.ft-sc h1 {
  font-weight: 600;
  margin: 35px;
  color: rgb(74, 74, 74);
  font-size: 42px;
}
.ft-sc-info {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.ft-sc-item {
  width: 350px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  padding: 20px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 50px;
  margin-bottom: 50px;
}
.ft-sc-item img {
  width: 75px;
}
.left {
  margin-left: 100px;
}
.right {
  margin-right: 100px;
}
.ft-sc-item h3 {
  color: #ED6823;
  font-size: 20px;
  line-height: 20px;
}
.ft-sc p {
  font-size: 18px;
}
.co-sc {
  display: flex;
  flex-direction: column;
  background-color: #E6E6E6;
  align-items: center;
}
.co-sc h1 {
  margin-top: 80px;
  text-align: center;
}
.co-sc h1 span {
  color: #f2985d;
  font-weight: bold;
}
.card-ts {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 22px;
  width: 380px;
  height: 250px;
  background-color: white;
  margin-top: 50px;
  margin-left: 25px;
  margin-right: 25px;
  margin-bottom: 50px;
  padding: 10px;
}
.ts-sc {
  display: flex;
}
.faq-sc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.faq-sc h1 {
  margin-top: 50px;
  font-weight: bold;
  font-size: 42px;
}
.drop-d {
  width: 50%;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #000000;
}
details {
  border: 0.5px solid #000000;
  overflow: hidden;
  width: 100%;
}
summary {
  padding: 10px 15px;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  border-radius: 0;
  border: 0.5px solid #000000;
  list-style: none;
  font-size: 16px;
}
details[open] summary {
  background: #e0e0e0;
}
details div {
  padding: 15px;
  background: #fff;
}
summary::before {
  content: "\25bc    ";
  font-size: 14px;
  transition: transform 0.3s ease;
  margin-left: 10px;
}
details[open] summary::after {
  transform: rotate(180deg);
}
details div {
  padding: 0 15px;
  background: #fff;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transform: scaleY(0);
  transform-origin: top;
  transition:
    transform 0.4s ease-in-out,
    opacity 0.3s ease-in-out,
    height 0.4s ease-in-out;
}
details[open] div {
  opacity: 1;
  height: auto;
  transform: scaleY(1);
  padding: 15px;
}
a {
  color: red;
  text-decoration: none;
}
.so-sc {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 25px;
}
.so-sc img {
  width: 30px;
  height: 30px;
}
.faq-sc h3 {
  text-align: center;
  margin-top: 50px;
}
@media (max-width: 768px) {
  .main-wrapper {
    height: 500px;
    align-items: center;
  }
  .nav-bar {
    width: 100%;
    border-radius: 0;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px;
    gap: 8px;
    display: none;
  }
  .nav-item {
    font-size: 16px;
    width: 100%;
    text-align: center;
  }
  .nav-button {
    padding: 8px 16px;
    font-size: 14px;
    border-radius: 15px;
  }
  .content {
    position: relative;
    width: 100%;
    border-radius: 0;
    padding: 20px 15px;
    margin-top: auto;
    margin-bottom: 20px;
  }
  .content h1 {
    font-size: 28px;
  }
  .content h2 {
    font-size: 20px;
  }
  .content p {
    font-size: 14px;
  }
  .logo3 {
    width: 100px;
    height: 50px;
  }
  .top p {
    font-size: 12px;
  }
  .cal-inst h1 {
    font-weight: bold;
    font-size: 36px;
    text-align: center;
  }
  .cal-inst h2 {
    font-size: 20px;
    text-align: center;
  }
  .nw-strp {
    gap: 10px;
    padding: 5px;
  }
  .nw-strp h5 {
    font-size: 11px;
  }
  .nw-strp-lft {
    gap: 5px;
  }
  .nw-strp-rgt {
    gap: 5px;
  }
  .bk-dm {
    padding: 5px;
    font-size: 10px;
  }
  .to-nmt {
    font-size: 10px;
    padding: 5px;
  }
  .trust-pilot img {
    width: 100px;
    height: 50px;
  }
  .hs-h1 {
    font-size: 30px;
  }
  .hero-section h1 {
    font-size: 30px;
    text-align: center;
  }
  .hero-section h2 {
    text-align: center;
    font-size: 18px;
    margin-left: 10px;
    margin-right: 10px;
    line-height: 20px;
  }
  .hero-section h3 {
    font-size: 22px;
    text-align: center;
  }
  .hero-section h4 {
    font-size: 16px;
  }
  .hs-btns {
    flex-direction: column;
  }
  .hero-section ul {
    flex-direction: column;
  }
  .stripe h3 {
    font-size: 20px;
    text-align: center;
  }
  .af-ts h1 {
    font-size: 24px;
  }
  .ft-sc {
    height: 100%;
  }
  .ft-sc h1 {
    text-align: center;
    font-size: 24px !important;
  }
  .ft-sc-item img {
    margin: 5dp;
    width: 45px;
  }
  .ft-sc-item h3 {
    font-size: 18px;
  }
  .left {
    margin-left: 00px;
  }
  .right {
    margin-right: 00px;
  }
  .container {
    padding: 10px;
    height: auto;
  }
  .header2 h1 {
    font-size: 18px;
    padding-left: 10px;
  }
  .header2 h2 {
    font-size: 14px;
    display: none;
  }
  .logo-mocktest {
    width: 80px;
    height: 30px;
  }
  .tabs {
    gap: 5px;
    flex-wrap: wrap;
  }
  .tab {
    padding: 8px 12px;
    font-size: 14px;
  }
  .timetable {
    margin-top: 10px;
  }
  .test-row {
    height: auto;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
  }
  .test-info.enhanced {
    height: auto;
    flex: none;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 10px;
    text-align: center;
  }
  .test-date {
    width: auto;
    font-size: 16px;
    margin-top: 10px;
  }
  .testName {
    font-size: 16px;
  }
  .test-centers {
    flex-direction: column;
    gap: 10px;
    margin: 10px 0;
  }
  .center {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
  }
  .book-btn {
    display: block;
    margin-top: 10px;
  }
  .ft-sc-info {
    flex-direction: column;
    align-items: center;
  }
  .ft-sc-item {
    width: 250px;
    height: 150px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .ft-sc-item h3 {
    font-size: 18px;
    line-height: 20px;
  }
  .ft-sc p {
    font-size: 14px;
  }
  .co-sc h1 {
    margin-top: 25px;
    font-size: 22px;
  }
  .ts-sc {
    flex-direction: column;
  }
  .card-ts {
    width: 300px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-ts h4 {
    font-size: 16px;
  }
  .card-ts p {
    font-size: 12px;
  }
  .faq-sc h1 {
    margin-top: 25px;
    font-size: 36px;
  }
  .drop-d {
    width: 90%;
  }
  .faq-sc h3 {
    font-size: 18px;
    line-height: 25px;
  }
}
/*# sourceMappingURL=gcsetimetable.component.css.map */
